import React, { Component } from 'react'
import styled from 'styled-components'
import { withTranslation } from 'react-i18next';
import { connect } from "react-redux";
import { bindActionCreators } from 'redux'
import { actions as employeeActions } from '../../../actions/employee'
import { actions as maintenanceActions } from '../../../actions/maintenance'

import { history } from '../../../store'


import Moment from 'moment';
import EmployeeService from '../../../services/Employee.service'

import RowInfo from './RowInfo'
import RowDetails from './RowDetails'

import VestsArea from './VestsArea'
import DocsArea from './DocsArea'
import UnvestedAwardDetailsDialog from '../UnvestedAwardDetailsDialog'
import VestedAwardDetailsDialog from "./VestedAwardDetailsDialog"


const NextVest = styled.div`
    display: table-cell;
    text-align: right;
    vertical-align: top;
    padding-top: 20px;

    // Mobile version.
    @media (max-width: 768px) {
        display: inline-block;
        width: 25%;
        padding: 13px 15px 14px 15px;
        text-align: left;
        height: 16px;
        border-right: 1px solid #DDDDDD;
    }

    > span {
        display: block;
        padding-top: 14px;
        padding-right: 15px;
        border-right: 1px solid #DDDDDD;
        height: 29px;

        font-family: Lato-Regular;
        font-size: 12px;
        color: #666666;
        line-height: 16px;

        // Mobile version.
        @media (max-width: 768px) {
            padding: 0;
            border-right: none;
            height: auto;
        }
    }
`

const NextVestDetails = styled.div`
    display: table-cell;
    width: 229px;
    vertical-align: top;
    padding-top: 21px;
    padding-left: 29px;

    // Mobile version.
    @media (max-width: 768px) {
        display: inline-block;
        width: auto;
        padding: 0 15px;
        height: 43px;
    }

    > div.next-vest-details-date {
        margin: 0;
        font-family: Lato-Regular;
        font-size: 14px;
        color: #2B2B2B;
        line-height: 22px;
    }

    > p {
        margin: 0;
        font-family: Lato-Regular;
        font-size: 12px;
        color: #666666;
        line-height: 16px;
        padding-top: 14px;
    }
`

const FullyVested = styled.div`
    display: table-cell;
    vertical-align: top;
    padding-top: 23px;
    padding-right: 40px;
    width: 310px;

    // Mobile version.
    @media (max-width: 768px) {
        display: block;
        width: auto;
        padding: 14px 15px 0 15px;
    }

    > div {
        background-color: #EDEDED;
        border: none;
        width: 270px;
        height: 33px;

        display: flex;
        justify-content: center;
        align-content: center;
        flex-direction: column;
        text-align: center;

        font-family: Lato-Regular;
        font-size: 12px;
        color: #666666;
        line-height: 16px;

        // Mobile version.
        @media (max-width: 768px) {
            width: 100%;
            padding: 0;
        }
    }
`

const RegionCode = {
    FRA: "FRA"
}

const AwardGrantType = {
    ISRRSU: "ISRRSU",
    FRARSU: "FRARSU",
    FRARSUNB: "FRARSUNB",
    FRARSU2NB: "FRARSU2NB",
    FRARSU2: "FRARSU2",
    FRARSU3: "FRARSU3",
    EXCHNG_OLD: "EXCHNG_OLD",
    FRANQ: "FRANQ",
    EXCHNG_NEW: "EXCHNG_NEW",
    NQ: "NQ",
    RSU: "RSU"
};

class AwardRow extends Component {

    constructor(props) {
        super(props);
        this.state = {
            unvestDialogVisible: false,
            vestedDialogVisible: false
        };
    }

    onSelectMenuItem = (key) => {
        this.props.onSelectAwardMenuItem(key, this.props.award.id)
    }

    onAcceptAward = () => {
        this.props.onAcceptAward(this.props.award)
    }

    onTransactionClicked = (transaction) => {
        this.setState(
            {
                vestedDialogVisible: true,
                award: this.props.award,
                transaction: transaction
            }
        )
    }

    onVestClicked = (vest) => {
        const isRsu = EmployeeService.isRSU(this.props.award)
        if(!isRsu) {
            this.setState(
                {
                    unvestDialogVisible: true,
                    award: this.props.award,
                    vest: vest
                }
            )
        } else {
            if(!vest.vested) {
                this.setState(
                    {
                        unvestDialogVisible: true,
                        award: this.props.award,
                        vest: vest
                    }
                )
            } else {
                this.setState(
                    {
                        vestedDialogVisible: true,
                        award: this.props.award,
                        vest: vest
                    }
                )
            }

        }
    }

    documentTileClicked = (doc) => {

        this.props.actions.maintenance.checkMaintenaceStatus().then(isLive => {
            if(isLive) {
                this.props.actions.employee.getDocument(this.props.employee.id, this.props.award.id, doc.id )
            } else {
              history.push("/maintenance", {})
            }
          })
    }

    getAwardMenuOptions = (t) => {
        var award = this.props.award
        var taxHide = this.props.taxHide
        var options = []
        options.push({value: 1, label: t('StockAwards.Award.AcceptAwardMenu.ViewPdfOption')})
        options.push({value: 2, label: t('StockAwards.Award.AcceptAwardMenu.DownloadExcelOption')})
        options.push({value: 3, label: t('StockAwards.Award.AcceptAwardMenu.ViewDetailedPdfOption')})
        options.push({value: 4, label: t('StockAwards.Award.AcceptAwardMenu.DownloadDetailedExcelOption')})
        options.push({value: 6, label: t('StockAwards.Award.AcceptAwardMenu.ViewStatementOption')})

        if (this.props.fractional_mode){
            options.push({value: 7, label: t('StockAwards.Award.AcceptAwardMenu.VestElectionOption')})
        }

        if(!this.props.fractional_mode && !award.fully_vested && !taxHide ){
            options.push({value: 5, label: t('StockAwards.Award.AcceptAwardMenu.TaxElectionOption')})
        }

        if(this.props.fractional_mode && !award.fully_vested && !taxHide ){
            options.push({value: 8, label: t('StockAwards.Award.AcceptAwardMenu.USFedRateOption')})
        }

        return options
    }

    calculateBadge = (award) => {
        const tax_rates = EmployeeService.getVestTaxRates(award)
        if(tax_rates) {
            if(tax_rates.max === 0 || tax_rates.max === tax_rates.min) {
                if(tax_rates.max !== this.props.default_tax_rate) {
                    return `${new Intl.NumberFormat(this.props.locale, {style: 'percent',minimumFractionDigits: 0, maximumFractionDigits: 2 }).format(tax_rates.min)}`
                }
            } else {
                return `${new Intl.NumberFormat(this.props.locale, {style: 'percent',minimumFractionDigits: 0, maximumFractionDigits: 2 }).format(tax_rates.min)} - ${new Intl.NumberFormat(this.props.locale, {style: 'percent',minimumFractionDigits: 0, maximumFractionDigits: 2 }).format(tax_rates.max)}`
            }
        }

        return null
    }

    election = (t, employee, vest, fractional_mode) => {
        if (vest){
            if (fractional_mode) {
                return EmployeeService.getVestFractionalElectionText(t, employee, vest)
            }
            else {
                return t(`TaxTreatment.${vest.tax_election.code}`)
            }
        }
        else {
            return ""
        }
    }

    contains = (items, comparator) => {
        for (let item of items) {
            if (item === comparator) {
                return true;
            }
        }
        return false;
    }

    getAwardGrantBadgeString = (t, grantType, regionCode) => {
        let badgeLabel = null;
        let badgeText = null;
    
        if (grantType === AwardGrantType.ISRRSU) {
            badgeLabel = t('StockAwards.Award.IsraeliQualifiedBadgeLabel');
            badgeText = t('StockAwards.Award.IsraeliQualifiedTooltipText');
        }
        
        if (regionCode === RegionCode.FRA) {
            if (this.contains([AwardGrantType.FRARSU, AwardGrantType.FRARSUNB], grantType)) {
                badgeLabel = t('StockAwards.Award.FrenchQualifiedPreMacronBadgeLabel')
                badgeText = t('StockAwards.Award.FrenchQualifiedTooltipText')
            }
            if (this.contains([AwardGrantType.FRARSU2NB, AwardGrantType.FRARSU2], grantType)) {
                badgeLabel = t('StockAwards.Award.FrenchQualifiedMacron2BadgeLabel')
                badgeText = t('StockAwards.Award.FrenchQualifiedTooltipText')
            }
            if (this.contains([AwardGrantType.FRARSU3], grantType)) {
                badgeLabel = t('StockAwards.Award.FrenchQualifiedMacron3BadgeLabel')
                badgeText = t('StockAwards.Award.FrenchQualifiedTooltipText')
            }
            if (this.contains(
                    [AwardGrantType.EXCHNG_OLD, AwardGrantType.RSU, AwardGrantType.NQ, AwardGrantType.EXCHNG_NEW, AwardGrantType.FRANQ], grantType
            )) {
                badgeLabel = t('StockAwards.Award.FrenchNonQualifiedBadgeLabel')
                badgeText = t('StockAwards.Award.FrenchQualifiedTooltipText')
            }   
        }

        return [badgeLabel, badgeText];
    }

    render() {

        const { t, employee, award, locale } = this.props
        const awardMenuOptions = this.getAwardMenuOptions(t)

        const nextVest = EmployeeService.getNextVest(award)
        const nextVestShares = nextVest ? new Intl.NumberFormat(locale).format(nextVest.vest_shares) : 0
        const awardShares = new Intl.NumberFormat(locale).format(award.shares_awarded)
        const election = this.election(t, this.props.employee, nextVest, this.props.fractional_mode)
        const isAwardAccepted = award.acceptance_status && award.acceptance_status.code === "A"
        const acceptedLabel = isAwardAccepted ? t('StockAwards.Award.AcceptedLabel', { accepted_date: Moment(award.acceptance_date).format('ll')}) : !award.acceptance_status || award.acceptance_status.code === "U" ? t('StockAwards.Award.NotAcceptedLabel') : ''
        const badgeLabel = this.calculateBadge(award)

        const transactions = EmployeeService.getTransactionsFromAward(award)
        const remainingVests = EmployeeService.getVestsFromAward(award, false)
        const vestedOptions = EmployeeService.getVestsOptionsFromAward(award)
        const documents = award.documents
        const sectioTitle = `${award.amazon_award_id} | ${award.amazon_award_name} `

        const isRSU = EmployeeService.isRSU(award)
        const isOption = EmployeeService.isOption(award)

        var [badgeLabel2, badgeText2] = this.getAwardGrantBadgeString(t, award.grant_type, award.award_region);
      
        var transactions_shares_transacted = 0
        if(award.transactions !== undefined){
            for (var i = 0; i < award.transactions.length; i++) {
                var transaction = award.transactions[i];
                transactions_shares_transacted += transaction.shares_transacted
            }
        }

        return (
            <section className="award-row" aria-label={sectioTitle}>
                <RowInfo title={sectioTitle}
                    rowId={this.props.rowId}
                    text={t('StockAwards.Award.AwardInfo', {share_quantity: awardShares, award_type: isRSU ? 'RSUs' : 'Options', share_date: Moment(award.awarded_date).format('ll')})}
                    acceptedLabel={acceptedLabel}
                    isAwardAccepted={isAwardAccepted}
                    badgeLabel={badgeLabel}
                    badgeText={t('StockAwards.Award.TooltipText')}
                    badgeLabel2={badgeLabel2}
                    badgeText2={badgeText2}
                    menuLabel={t('StockAwards.Award.MenuLabel')}
                    menuOptions={awardMenuOptions}
                    onToggle={this.onToggle}
                    onAcceptAward={this.onAcceptAward}
                    onSelectMenuItem={this.onSelectMenuItem}>
                    {!award.fully_vested && isRSU &&
                        <NextVest>
                            <span>{t('StockAwards.Award.NextVestLabel')}</span>
                        </NextVest>
                    }
                    {!award.fully_vested && isOption &&
                        <NextVest>
                            {transactions_shares_transacted < award.shares_awarded &&
                                <span>
                                    <a className="custom-link" target="_blank" href={this.props.broker_url}>
                                        {t('StockAwards.Award.ExerciseAvailableStocksLink')}
                                    </a>
                                </span>
                            }
                        </NextVest>
                    }
                    {!award.fully_vested && isRSU &&
                        <NextVestDetails>
                            <div className="next-vest-details-date">{ nextVest ? Moment(nextVest.vest_date).format('ll') : ""}</div>
                            <p>{t('StockAwards.Award.NextVestInfo', {share_quantity: nextVestShares, election: election})}</p>
                        </NextVestDetails>
                    }
                    {!award.fully_vested && isOption &&
                        <NextVestDetails>
                            <p>
                                {t('StockAwards.Award.StrikePriceInfo', {value:
                                    new Intl.NumberFormat(locale, { style: 'currency', currency: 'USD' }).format(award.strike_price)
                                })}
                            </p>
                        </NextVestDetails>
                    }
                    {award.fully_vested &&
                        <FullyVested>
                            <div>{t('StockAwards.Award.FullyVestedLabel')}</div>
                        </FullyVested>
                    }
                </RowInfo>
                <RowDetails rowId={this.props.rowId} className="row-detail">
                    {transactions && transactions.length > 0 &&
                        <VestsArea
                            employee={this.props.employee}
                            areaId={`${this.props.rowId}_completed_vests`}
                            title={isRSU ? t('StockAwards.VestsSection.CompletedVestsSectionTitle') : t('StockAwards.VestsSection.ExercisesVestsSectionTitle')} 
                            transactions={transactions}
                            onVestClicked={this.onTransactionClicked}
                            isRSU={isRSU}
                            footerMid={EmployeeService.getBrokers(t, award.tax_broker.name, award.net_broker.name, award.mobile_tax_sale_in)[0]}
                            footerBottom={EmployeeService.getBrokers(t, award.tax_broker.name, award.net_broker.name, award.mobile_tax_sale_in)[1]}
                            broker={EmployeeService.getBrokersDisplay(t, award.tax_broker.name, award.net_broker.name, award.mobile_tax_sale_in)}
                            />
                    }

                    {isOption && vestedOptions && vestedOptions.length > 0 &&
                        <VestsArea
                            employee={this.props.employee}
                            areaId={`${this.props.rowId}_completed_vests`}
                            title={t('StockAwards.VestsSection.CompletedVestsSectionTitle')}
                            onVestClicked={this.onVestClicked}
                            vests={vestedOptions}
                            isRSU={isRSU}
                            footerMid={EmployeeService.getBrokers(t, award.tax_broker.name, award.net_broker.name, award.mobile_tax_sale_in)[0]}
                            footerBottom={EmployeeService.getBrokers(t, award.tax_broker.name, award.net_broker.name, award.mobile_tax_sale_in)[1]}
                            broker={EmployeeService.getBrokersDisplay(t, award.tax_broker.name, award.net_broker.name, award.mobile_tax_sale_in)}
                            />
                    }

                    {remainingVests && remainingVests.length > 0 &&
                        <VestsArea
                            employee={this.props.employee}
                            areaId={`${this.props.rowId}_remaining_vests`}
                            title={t('StockAwards.VestsSection.RemainingVestsSectionTitle')}
                            onVestClicked={this.onVestClicked}
                            vests={remainingVests}
                            award={this.props.award}
                            isRSU={isRSU}
                            footerMid={EmployeeService.getBrokers(t, award.tax_broker.name, award.net_broker.name, award.mobile_tax_sale_in)[0]}
                            footerBottom={EmployeeService.getBrokers(t, award.tax_broker.name, award.net_broker.name, award.mobile_tax_sale_in)[1]}
                            broker={EmployeeService.getBrokersDisplay(t, award.tax_broker.name, award.net_broker.name, award.mobile_tax_sale_in)}
                            />
                    }

                    {documents && documents.length > 0 &&
                        <DocsArea
                            areaId={`${this.props.rowId}_docs`}
                            title={t('StockAwards.DocumentSection.Title')}
                            documents={documents}
                            onFooterClicked={this.documentTileClicked}
                            />
                    }

                </RowDetails>

                <UnvestedAwardDetailsDialog
                    employee={this.props.employee}
                    visible={this.state.unvestDialogVisible}
                    award={this.state.award}
                    vest={this.state.vest}
                    broker={award.tax_broker}
                    brokers={EmployeeService.getBrokers(t, award.tax_broker.name, award.net_broker.name, award.mobile_tax_sale_in)}
                    done={() => this.setState({unvestDialogVisible: false})}
                    onChangePaymentMethod={this.props.onChangePaymentMethod}
                />

                <VestedAwardDetailsDialog
                    visible = {this.state.vestedDialogVisible}
                    onCloseDialog = {() => this.setState({vestedDialogVisible: false})}
                    award={this.state.award}
                    transaction={this.state.transaction}
                    brokers={EmployeeService.getBrokers(t, award.tax_broker.name, award.net_broker.name, award.mobile_tax_sale_in)}
                />
            </section>
         )
    }
}

const mapState = state => ({
    employee: state.employee,
    locale: state.employee.language,
    broker: state.employee.broker ? state.employee.broker.name : '',
    broker_url: EmployeeService.getEmployeeBrokerUrl(state.employee),
    default_tax_rate : state.configuration.default_tax_rate,
    fractional_mode: state.static_content.fractional_mode
});

const mapDispatchToProps = dispatch => ({
    actions: {
      employee: bindActionCreators(employeeActions, dispatch),
      maintenance: bindActionCreators(maintenanceActions, dispatch),
    }
  })

export default connect(mapState,mapDispatchToProps)(withTranslation("translations")(AwardRow));
